"use client";

import { redirect } from "next/navigation";
import React from "react";
import { useRouter } from "next/navigation";
import { parseNumberFromAttributeValue } from "@/apiUtils/commonUtils";

interface IProps {
  selectedVariantId: string;
  multipleLabel: string;
  singleLabel: string;
  title: string;
  data: Array<LensPackItem>;
  lang: "en" | "ar";
  handlePackSelection: (id: string) => void;
  handleVariantselection: (id: string) => void;
  selectedPack: string;
}

export interface LensPackItem {
  quantity: number;
  packSize: string;
  variantId?: string;
  landingpageBaseUrl?: string;
}

const LensePackSize = ({
  data,
  lang,
  multipleLabel,
  singleLabel,
  title,
  selectedPack,
  handlePackSelection,
  handleVariantselection,
}: IProps) => {
  const router = useRouter();

  function getLabel(clPackSize: string) {
    const packSize = parseNumberFromAttributeValue(clPackSize);
    if (packSize) {
      return packSize > 1
        ? multipleLabel.replace("{{count}}", packSize?.toString())
        : singleLabel.replace("{{count}}", packSize?.toString());
    }
  }

  function handleOptionClick(url: string) {
    if (url) {
      router.push(url);
    }
  }

  function onClick(item: LensPackItem) {
    handlePackSelection(item.packSize);
    handleVariantselection(item.variantId ?? "");
  }

  console.log({ selectedPack });
  return (
    <div>
      <h2 className="font-semibold">{lang === "ar" ? title : "Pack size"}: </h2>
      <form className="flex flex-wrap items-center gap-4 py-2">
        {data?.map((item, idx) => {
          return (
            <span key={idx} className="flex items-center gap-2">
              <input
                type="radio"
                alt="pack_size"
                id={item?.variantId}
                name="packSize"
                className="focus:outline-none focus:ring-0 focus:ring-white"
                onClick={() => onClick(item)}
                defaultChecked={item.packSize === selectedPack}
              />
              <label htmlFor={item?.variantId} className="cursor-pointer text-sm">
                {getLabel(item.packSize)}
              </label>
            </span>
          );
        })}
      </form>
    </div>
  );
};

export default LensePackSize;
